import { render } from "./RemoteAssistDrawer.vue?vue&type=template&id=50256874&scoped=true"
import script from "./RemoteAssistDrawer.vue?vue&type=script&lang=js"
export * from "./RemoteAssistDrawer.vue?vue&type=script&lang=js"

import "./RemoteAssistDrawer.vue?vue&type=style&index=0&id=50256874&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50256874"]])

export default __exports__